export default __webpack_public_path__ + "static/this-is-new-jira-5d5e1b921a266fde9e215607ffbb723323ccaafb61e7ba09b95380aa831bd0f1.png";